import { hasWindow } from "@omni/utils/dom.utils";
import { isDefined } from "@omni/utils/helper.utils";
import { useCallback } from "react";

export const useHistoryState = <T>() => {
    const get = useCallback(<T>() => {
        if (!hasWindow()) return undefined;

        const state = history.state?.state as T | undefined;
        const currentStep = history.state?.currentStep as number | undefined;

        if (!isDefined(state) || !isDefined(currentStep)) return undefined;

        return {
            state,
            currentStep
        };
    }, []);

    const push = useCallback(
        <T>(historyState: { state: T; currentStep: number }) => {
            if (!hasWindow()) return;

            history.pushState(
                {
                    state: historyState.state,
                    currentStep: historyState.currentStep
                },
                "",
                window.location.href
            );
        },
        []
    );

    const replace = useCallback(
        <T>(historyState: { state: T; currentStep: number }) => {
            if (!hasWindow()) return;

            history.replaceState(
                {
                    state: historyState.state,
                    currentStep: historyState.currentStep
                },
                "",
                window.location.href
            );
        },
        []
    );

    return {
        getHistoryState: get<T>,
        pushHistoryState: push<T>,
        replaceHistoryState: replace<T>
    };
};
